var _style, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "410px",
    height: "44px",
    viewBox: "0 0 410 44",
    style: {
      enableBackground: "new 0 0 410 44"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:#411564;}\n\t.st5{fill:#F6D000;}\n\t.st6{fill:#F4D018;}\n\t.st7{fill:#006DB0;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:url(#SVGID_5_);}\n\t.st10{fill:url(#SVGID_6_);}\n\t.st11{fill:url(#SVGID_7_);}\n\t.st12{fill:url(#SVGID_8_);}\n\t.st13{fill:#462066;}\n\t.st14{fill:#212529;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.7187,
    y1: -661.6361,
    x2: 29.7187,
    y2: -705.252,
    gradientTransform: "matrix(1 0 0 -1 0 -661.4468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#955EB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0305,
    style: {
      stopColor: "#8551A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0917,
    style: {
      stopColor: "#6D3B90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#592A7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    style: {
      stopColor: "#4B1E6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3353,
    style: {
      stopColor: "#431766"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5075,
    style: {
      stopColor: "#411564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    style: {
      stopColor: "#411564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9406,
    style: {
      stopColor: "#3C155E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9858,
    style: {
      stopColor: "#2F154D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#291546"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.4,0.2H7.5C3.4,0.2,0,3.6,0,7.7v28.6c0,4.1,3.4,7.5,7.5,7.5h51.9C59.4,43.8,59.4,0.2,59.4,0.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -480.3091,
    y1: -661.6361,
    x2: -480.3091,
    y2: -705.2575,
    gradientTransform: "matrix(-1 0 0 -1 -391.1586 -661.4468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0169,
    style: {
      stopColor: "#FEECB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0491,
    style: {
      stopColor: "#FCE68A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    style: {
      stopColor: "#FAE065"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    style: {
      stopColor: "#F9DB46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1615,
    style: {
      stopColor: "#F8D72C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2059,
    style: {
      stopColor: "#F7D418"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2569,
    style: {
      stopColor: "#F6D20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3201,
    style: {
      stopColor: "#F6D002"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4322,
    style: {
      stopColor: "#F6D000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#F6D000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    style: {
      stopColor: "#F6D000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9336,
    style: {
      stopColor: "#F6CD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#F6C200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6B200"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,0.2h51.9c4.1,0,7.5,3.4,7.5,7.5v28.6c0,4.1-3.4,7.5-7.5,7.5H59.4V0.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.3906,
    y1: -669.4923,
    x2: 31.3906,
    y2: -683.6069,
    gradientTransform: "matrix(1 0 0 -1 0 -661.4468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6D000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.1,35.6L50,23.8l5.4-8.6h-6.2L44.6,24l5.3,11.6H56.1z M44.2,7.8h-5.4v27.8h5.4V7.8z M34,25.4 c0-2.2-0.2-4-0.7-5.3c-0.5-1.4-1.2-2.5-2-3.2c-0.8-0.8-1.7-1.3-2.7-1.6c-1-0.3-2-0.4-2.9-0.4c-1,0-2.1,0.1-3.1,0.4s-2,0.8-2.8,1.6 c-0.8,0.8-1.5,1.9-2,3.2c-0.5,1.4-0.8,3.1-0.8,5.3c0,2.4,0.3,4.3,0.9,5.7c0.6,1.4,1.3,2.5,2.3,3.2c0.9,0.7,1.9,1.2,3.1,1.4 c1.1,0.2,2.2,0.3,3.3,0.3c0.8,0,1.6,0,2.4-0.2c0.8-0.1,1.4-0.2,2-0.4c0.6-0.1,1.2-0.3,1.9-0.5v-4.3c-0.8,0.2-1.5,0.4-2.1,0.5 c-0.6,0.1-1.3,0.3-2,0.4c-0.7,0.1-1.4,0.2-2.1,0.2c-0.4,0-0.9,0-1.3-0.2c-0.5-0.1-0.9-0.3-1.3-0.6c-0.4-0.3-0.7-0.8-1-1.4 c-0.3-0.6-0.4-1.4-0.4-2.4h11.6L34,25.4z M22.3,23.8c0-2,0.3-3.5,0.8-4.3c0.5-0.8,1.4-1.2,2.5-1.2c0.5,0,0.9,0.1,1.3,0.2 c0.4,0.2,0.7,0.4,0.9,0.8c0.2,0.4,0.4,1,0.6,1.7s0.2,1.6,0.2,2.7L22.3,23.8L22.3,23.8z M12.1,7.8H6.7v27.8h5.4V7.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.5506,
    y1: -669.2779,
    x2: 87.5506,
    y2: -697.4549,
    gradientTransform: "matrix(1 0 0 -1 0 -661.4468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#955EB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0746,
    style: {
      stopColor: "#8550A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    style: {
      stopColor: "#67368B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    style: {
      stopColor: "#522475"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5416,
    style: {
      stopColor: "#451968"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6834,
    style: {
      stopColor: "#411564"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113,15c-0.8-0.2-1.6-0.2-2.3-0.2c-0.6,0-1.2,0.1-1.6,0.4c-0.5,0.3-0.9,0.5-1.2,0.8c-0.3,0.3-0.6,0.7-1,1.2 l-0.7-2h-4.3v20.5h5.4V20.5c0,0,0.2-0.1,0.4-0.2c0.2-0.1,0.6-0.2,1-0.3c0.4-0.1,0.8-0.2,1.2-0.2c0.4,0,0.8,0,1.3,0.1 c0.5,0.1,0.9,0.1,1.2,0.2c0.3,0.1,0.5,0.1,0.5,0.1L113,15L113,15z M97.5,25.4c0-2.2-0.2-4-0.7-5.3c-0.5-1.4-1.2-2.5-2-3.2 c-0.8-0.8-1.7-1.3-2.7-1.6c-1-0.3-2-0.4-2.9-0.4c-1,0-2.1,0.1-3.1,0.4s-2,0.8-2.8,1.6c-0.8,0.8-1.5,1.9-2,3.2 c-0.5,1.4-0.8,3.1-0.8,5.3c0,2.4,0.3,4.3,0.9,5.7c0.6,1.4,1.3,2.5,2.3,3.2c0.9,0.7,1.9,1.2,3.1,1.4C87.9,35.9,89,36,90,36 c0.8,0,1.6,0,2.4-0.2c0.8-0.1,1.4-0.2,2-0.4c0.6-0.1,1.2-0.3,1.9-0.5v-4.3c-0.8,0.2-1.5,0.4-2.1,0.5c-0.6,0.1-1.3,0.3-2,0.4 c-0.7,0.1-1.4,0.2-2.1,0.2c-0.4,0-0.9,0-1.4-0.2c-0.5-0.1-0.9-0.3-1.3-0.6c-0.4-0.3-0.7-0.8-1-1.4c-0.3-0.6-0.4-1.4-0.4-2.4h11.6 L97.5,25.4z M85.9,23.8c0-2,0.3-3.5,0.8-4.3c0.5-0.8,1.4-1.2,2.5-1.2c0.5,0,0.9,0.1,1.3,0.2s0.7,0.4,0.9,0.8 c0.2,0.4,0.4,1,0.6,1.7s0.2,1.6,0.2,2.7L85.9,23.8L85.9,23.8z M79.5,35.6l-6.1-11.8l5.4-8.6h-6.2L68,24l5.3,11.6L79.5,35.6z  M67.5,7.8h-5.4v27.8h5.4V7.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M142.7,36h-3.1l-5.1-19.4h2.9l2.8,13c0.4,1.9,0.9,4.8,1,5.1c0-0.1,0.6-3.2,1-5.1l2.8-13h2.9L142.7,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.5,36V16.6h9.4v2.4H153v5.4h6.4v2.2H153v7.1h6.9V36H150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171.9,36l-1.4-4.4c-0.5-1.5-1.1-3-2-3.8c-0.8,0.1-1.6,0.1-2.4,0.2V36h-2.5V16.6h4.1c3.8,0,7,0.7,7,5.5 c0,3-1.6,4.5-3.8,5.2c0.9,0.9,1.6,2,1.9,3.2l2.1,5.5L171.9,36z M167.2,18.8H166v7.1c4.5-0.1,6.1-1,6.1-3.9 C172.1,19,170.3,18.8,167.2,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M178.5,36V16.6h9.4v2.4H181v5.4h6.4v2.2H181v7.1h6.9V36H178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191.5,36V16.6h2.6V36H191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M207.7,36l-5.1-10.5c-1.2-2.6-2.2-5.2-2.2-5.2s0.4,3.7,0.4,5.8V36h-2.5V16.6h2.5l4.9,10.1 c0.8,1.8,1.6,3.6,2.2,5.4c0-0.2-0.4-3.9-0.4-6v-9.5h2.5V36L207.7,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M216.5,36.3c-1.2,0-2.5-0.2-3.7-0.6v-2.3c1.2,0.4,2.4,0.6,3.6,0.7c1.9,0,3.4-0.6,3.4-3.1c0-1.7-1-2.6-2.2-3.4 l-2-1.4c-1.6-1.1-3-2.5-3-4.8c0-3.9,3.1-5.1,5.6-5.1c1.1,0,2.3,0.2,3.3,0.6v2.2c-1.1-0.4-2.2-0.7-3.3-0.7c-1.9,0-3.2,0.7-3.2,2.7 c0,1.4,1,2.2,2.2,3.1l1.6,1.1c1.7,1.2,3.5,2.6,3.5,5.4C222.3,35.4,219.5,36.3,216.5,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M241.1,36h-3.3l-2.7-13.2c-0.4-1.9-0.9-4.6-0.9-4.9c0,0.1-0.5,3-0.9,4.9L230.6,36h-3.2l-3.6-19.4h2.9 l1.7,13.1c0.2,1.7,0.6,4.8,0.6,5c0-0.2,0.5-3.3,0.9-5l2.8-13.1h3.4l2.7,13.1c0.3,1.6,0.8,4.6,0.9,5c0-0.2,0.4-3.3,0.6-5l1.7-13.1 h2.9L241.1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M247.4,36V16.6h9.4v2.4h-6.9v5.4h6.4v2.2h-6.4v7.1h6.9V36H247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M269.9,18.9h-4.4V36h-2.5V18.9h-4.7v-2.3h11.9L269.9,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M282.6,18.9h-4.4V36h-2.5V18.9H271v-2.3h11.9L282.6,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M288.3,36h-3.2V16.6h3.5c4.7,0,7.3,0.7,7.3,5c0.1,2-1.3,3.8-3.3,4.3c2.1,0.3,3.9,1.4,3.9,4.5 C296.4,35.6,293.4,36,288.3,36z M288.5,18.6h-1V25h1c3.4,0,4.8-0.6,4.8-3.3S291.9,18.6,288.5,18.6L288.5,18.6z M288.6,27h-1v7h1.2 c3.5,0,5.2-0.4,5.2-3.5C294,27.5,291.9,27,288.6,27L288.6,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M299.1,36V16.6h9.4v2.4h-6.9v5.4h6.4v2.2h-6.4v7.1h6.9V36H299.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M327.3,36H324l-2.7-13.2c-0.4-1.9-0.9-4.6-0.9-4.9c0,0.1-0.6,3-0.9,4.9L316.7,36h-3.2l-3.6-19.4h2.9l1.7,13.1 c0.2,1.7,0.6,4.8,0.6,5c0-0.2,0.5-3.3,0.9-5l2.8-13.1h3.5l2.7,13.1c0.3,1.6,0.8,4.6,0.9,5c0-0.2,0.4-3.3,0.6-5l1.7-13.1h2.9 L327.3,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M333.7,36V16.6h9.4v2.4h-6.9v5.4h6.4v2.2h-6.4v7.1h6.9V36H333.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M354.8,36l-1.4-4.4c-0.5-1.5-1.1-3-2-3.8c-0.8,0.1-1.6,0.1-2.4,0.2V36h-2.5V16.6h4.1c3.8,0,7,0.7,7,5.5 c0,3-1.6,4.5-3.8,5.2c0.9,0.9,1.6,2,1.9,3.2l2.1,5.5L354.8,36z M350.1,18.8h-1.1v7.1c4.5-0.1,6.1-1,6.1-3.9 C355,19,353.2,18.8,350.1,18.8L350.1,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M364.4,36h-3.2V16.6h3.5c4.7,0,7.3,0.7,7.3,5c0.1,2-1.3,3.8-3.3,4.3c2.1,0.3,3.9,1.4,3.9,4.5 C372.5,35.6,369.5,36,364.4,36z M364.6,18.6h-1V25h1c3.4,0,4.8-0.6,4.8-3.3S367.9,18.6,364.6,18.6L364.6,18.6z M364.7,27h-1v7h1.2 c3.5,0,5.2-0.4,5.2-3.5C370,27.5,368,27,364.7,27z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "383.6,40.5 387.9,39 389.5,43.2 394.7,32.2 388.9,29.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "404.7,29.5 398.9,32.2 404.1,43.2 405.8,39 410,40.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M396.8,10.4c-5.7,0-10.2,4.6-10.2,10.2s4.6,10.2,10.2,10.2c5.7,0,10.2-4.6,10.2-10.2v0 C407,15,402.5,10.4,396.8,10.4 M396.8,28.4c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8l0,0 C404.5,25,401.1,28.4,396.8,28.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M398.4,16.3c0-0.1,0-0.1-0.1-0.2c0,0,0,0,0-0.1c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.2-0.2 c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.2,0h-0.1c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.2,0-0.2,0.1h-0.1l-2.6,1.4c-0.6,0.3-0.8,1.1-0.5,1.7c0.2,0.4,0.6,0.6,1.1,0.6c0.2,0,0.4-0.1,0.6-0.1l0.8-0.4v5.5 c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-7.6c0,0,0,0,0-0.1C398.4,16.5,398.4,16.4,398.4,16.3"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.7487089e6785ed9077f68e15a1e6b7ed.svg";